import { useActiveClaimCondition, useContract } from '@thirdweb-dev/react'
import { useVault } from '~/hooks/useItem'
import { NftCard } from '~/components/NftCard'
import { NftCardLoading } from '~/components/CollectionsLoadingState'
import { VaultWithCollectionAndTokenId } from '~/domain/Vault'

interface DropVaultCardProps {
  vault: VaultWithCollectionAndTokenId
}

export const DropVaultCard: React.FC<DropVaultCardProps> = ({ vault }) => {
  const {
    data: item,
    isLoading: isVaultLoading,
    isError: isVaultError,
    error: vaultError,
  } = useVault(vault.collection, vault.tokenId, vault)
  const {
    contract,
    isLoading: isContractLoading,
    isError: isContractError,
    error: contractError,
  } = useContract(item?.vault?.contract.address)
  const {
    data: claimCondition,
    isLoading: isConditionLoading,
    isError: isConditionError,
    error: conditionError,
  } = useActiveClaimCondition(contract)

  const isLoading = isVaultLoading || isContractLoading || isConditionLoading
  const isError = isVaultError || isContractError || isConditionError

  if (isLoading) {
    return <NftCardLoading/>
  }

  if (isError) {
    if (isVaultError) console.error(vaultError)
    if (isContractError) console.error(contractError)
    if (isConditionError) console.error(conditionError)

    return null
  }

  if (!item) return null

  const showMintPrice = claimCondition !== undefined && Number(claimCondition.availableSupply) > 0

  return (
    <NftCard
      key={ vault.contract.address }
      collection={ vault.collection }
      nft={ item }
      dropMintPrice={ showMintPrice ? claimCondition?.currencyMetadata.displayValue : undefined }
      dropMintCurrencySymbol={ showMintPrice ? claimCondition?.currencyMetadata.symbol : undefined }
    />
  )
}
